module.exports = __webpack_public_path__ + "08_hige_gray.2211b995.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer3/08_hige_gray.png
// module id = yQKU
// module chunks = 0